import React from 'react';
import { motion } from 'framer-motion';

const TeamSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
      },
    },
  };

  return (
    <section className="py-8 bg-black text-white relative overflow-hidden min-h-screen flex flex-col justify-center">
      {/* Background text */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.05] pointer-events-none overflow-hidden">
        <span className="text-[30vw] font-black whitespace-nowrap select-none text-white">TEAM</span>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-14 md:mb-20"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Visionäre Führung</h2>
          <p className="text-gray-300 max-w-3xl mx-auto text-lg">
            Hinter YADE Home steht eine visionäre Führung, die die Zukunft des Wohnens bereits heute gestaltet.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center"
        >
          {/* Ohne Foto: Name und Rolle typografisch */}
          <motion.div variants={itemVariants}>
            <h3 className="font-bold text-4xl md:text-6xl text-white tracking-tight">Deniz Adigüzel</h3>
            <p className="text-gray-400 text-lg mt-3">Geschäftsführer, YADE Home GmbH</p>
          </motion.div>

          <motion.div variants={itemVariants} className="mt-10 border-t border-white/15 pt-10">
            <p className="text-gray-300 text-lg md:text-xl leading-relaxed">
              „Die Zukunft des Wohnens entsteht durch visionäre Digitalisierung und grenzenlose Kreativität. Gemeinsam mit ausgewählten Partnern werden nicht nur Immobilien geschaffen, sondern Lebensträume verwirklicht. Durch individuelle Betreuung auf höchstem Niveau entstehen nicht nur zufriedene, sondern begeisterte Kunden, die zu Botschaftern außergewöhnlicher Wohnkultur werden.“
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default TeamSection;
